import { Controller } from "@hotwired/stimulus";

// Shows a Bulma spinner on the submitting <button> elements while a Turbo form
// submission is in flight.
//
//   data-controller="submit-spinner"
//   data-action="turbo:submit-start->submit-spinner#start turbo:submit-end->submit-spinner#end"
type FormSubmissionEvent = CustomEvent<{ formSubmission: { submitter?: HTMLElement } }>;

export default class extends Controller {

  start(event: FormSubmissionEvent) {
    event.detail.formSubmission.submitter?.classList.add("is-loading");
  }

  end(event: FormSubmissionEvent) {
    event.detail.formSubmission.submitter?.classList.remove("is-loading");
  }
}
